export enum ExtensionTypes {
	user = 'user',
	group = 'group',
	service = 'service',
	external = 'external',
	queue = 'queue',
	device = 'device',
}
